
document.addEventListener("DOMContentLoaded", function () {

// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide:not(.no-custom-arrow):not(.CenterMoodSlider):not(.marquee-slider)').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;


    // 👉 Get custom breakpoint values
    const br1440 = parseInt(element.dataset['1440br']);
    const br1199 = parseInt(element.dataset['1199br']);
    const br989  = parseInt(element.dataset['989br']);
    const br767  = parseInt(element.dataset['767br']);
    const br576  = parseInt(element.dataset['576br']);

    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      updateOnMove: true,
      interval: autoplayintervel || 3000,
      breakpoints: {
        1440: {
          pagination: paginatione,
          drag: true,
          perPage: isBanner ? mobileshow : (br1440 || perPage),
          gap: "16px"
        },
        1199: {
          pagination: paginatione,
          drag: true,
           perPage: isBanner ? mobileshow : (br1199 || mobileshow),
          gap: "16px"
        },
        989: {
          pagination: paginatione,
          drag: true,
          perPage: isBanner ? mobileshow : (br989 || mobileshow),
          gap: "16px"
        },
        767: {
          perPage: isBanner ? mobileshow : (br767 || mobileshow),
          arrows: arrows,
          pagination: paginatione,
          gap: "10px"
        },
        576: {
          perPage: isBanner ? mobileshow : (br576 || mobileshow),
          arrows: false,
          pagination: true
        }
      }
    });

    splide.on('mounted move resized', function () {

  const totalSlides = splide.length;
  const index = splide.index;
  const perPage = splide.options.perPage;
  const lastIndex = totalSlides - perPage;

  const prevArrow = element.querySelector('.splide__arrow--prev');
  const nextArrow = element.querySelector('.splide__arrow--next');

  if (!prevArrow || !nextArrow) return;

  // Hide arrows if all slides fit
  if (totalSlides <= perPage) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
    return;
  } else {
    prevArrow.style.display = '';
    nextArrow.style.display = '';
  }

  // Reset disabled state
  prevArrow.classList.remove('disabled');
  nextArrow.classList.remove('disabled');

  // Disable prev at first slide
  if (index === 0) {
    prevArrow.classList.add('disabled');
  }

  // Disable next at last slide
  if (index >= lastIndex) {
    nextArrow.classList.add('disabled');
  }

});


splide.mount();
    
    
  });
  
};

SplideSliderFunction();







// center mood slider
window.SplideSliderFunctionForCenterMood = function () {
  document.querySelectorAll('.CenterMoodSlider:not(.no-custom-arrow)').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;

   

    // 👉 Get custom breakpoint values
    const br1440 = parseInt(element.dataset['1440br']);
    const br1199 = parseInt(element.dataset['1199br']);
    const br989  = parseInt(element.dataset['989br']);
    const br767  = parseInt(element.dataset['767br']);
    const br576  = parseInt(element.dataset['576br']);

    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      updateOnMove: true,
      interval: autoplayintervel || 3000,
     focus: 'center', 
      breakpoints: {
        1440: {
          pagination: paginatione,
          drag: true,
          perPage: isBanner ? mobileshow : (br1440 || perPage),
          gap: "16px"
        },
        1199: {
          pagination: paginatione,
          drag: true,
           perPage: isBanner ? mobileshow : (br1199 || mobileshow),
          gap: "16px"
        },
        989: {
          pagination: paginatione,
          drag: true,
          perPage: isBanner ? mobileshow : (br989 || mobileshow),
          gap: "16px"
        },
        767: {
          perPage: isBanner ? mobileshow : (br767 || mobileshow),
          arrows: arrows,
          pagination: paginatione,
          gap: "10px"
        },
        576: {
          perPage: isBanner ? mobileshow : (br576 || mobileshow),
          arrows: false,
          pagination: true
        }
      }
    });

    splide.on('mounted move resized', function () {

  const totalSlides = splide.length;
  const index = splide.index;
  const perPage = splide.options.perPage;
  const lastIndex = totalSlides - perPage;

  const prevArrow = element.querySelector('.splide__arrow--prev');
  const nextArrow = element.querySelector('.splide__arrow--next');

  if (!prevArrow || !nextArrow) return;

  // Hide arrows if all slides fit
  if (totalSlides <= perPage) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
    return;
  } else {
    prevArrow.style.display = '';
    nextArrow.style.display = '';
  }

  // Reset disabled state
  prevArrow.classList.remove('disabled');
  nextArrow.classList.remove('disabled');

  // Disable prev at first slide
  if (index === 0) {
    prevArrow.classList.add('disabled');
  }

  // Disable next at last slide
  if (index >= lastIndex) {
    nextArrow.classList.add('disabled');
  }

});


splide.mount();
    
    
  });
  
};

SplideSliderFunctionForCenterMood();





// var imageEl = document.querySelector('.testimonials-image-slider');
// var messageEl = document.querySelector('.testimonials-message-slider');

//    if (imageEl && messageEl) {
//     if (
//         imageEl.querySelectorAll('.splide__slide').length > 0 &&
//         messageEl.querySelectorAll('.splide__slide').length > 0
//     ) {

//         var imageSplide = new Splide(imageEl, {
//             type: 'loop',
//             pagination: true,
//             arrows: true,
//             isNavigation: true,
//             focus: 'center',
//             gap: '0px',
//             updateOnMove: true,
//             wheel: true,  
//             perPage: 5,
//             perMove: 1
//         });

//         var messageSplide = new Splide(messageEl, {
//             type: 'loop',
//             pagination: true,
//             arrows: false,
//             speed: 600,
//             drag: true,
//             updateOnMove: true,
//             wheel: true,
//              focus: 'center',
//         });

//         imageSplide.mount();
//         messageSplide.sync(imageSplide).mount();
//     }
// }

var imageEl = document.querySelector('.testimonials-image-slider');
var messageEl = document.querySelector('.testimonials-message-slider');

if (imageEl && messageEl) {
    if (
        imageEl.querySelectorAll('.splide__slide').length > 0 &&
        messageEl.querySelectorAll('.splide__slide').length > 0
    ) {

        var imageSplide = new Splide(imageEl, {
            type: 'loop',
            pagination: true,
            arrows: true,
            isNavigation: true,
            focus: 'center',
            gap: '0px',
            updateOnMove: true,
            wheel: true,
            perPage: 5,
            perMove: 1,
            start: 0   // ✅ force start index
        });

        var messageSplide = new Splide(messageEl, {
            type: 'loop',
            pagination: true,
            arrows: false,
            speed: 600,
            drag: true,
            updateOnMove: true,
            wheel: true,
            focus: 'center',
            start: 0   // ✅ same index
        });

        // ✅ Sync BEFORE mount
        messageSplide.sync(imageSplide);

        imageSplide.mount();
        messageSplide.mount();
    }
}

setTimeout(() => {
    imageSplide.refresh();
    messageSplide.refresh();
}, 1000);


// faq details
     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
                dataText.style.display = "none";
            }
         }           
        });

    });






// chat open
 
 document.addEventListener("click", function (e) {

  const chatLink = e.target.closest('#HeaderMenu-more-at-i-isha-chat-with-us');

  if (chatLink) {
    e.preventDefault();

    const chatEl = document.querySelector('inbox-online-store-chat');

    if (chatEl && chatEl.shadowRoot) {
      const chatButton = chatEl.shadowRoot.querySelector('button');

      if (chatButton) {
        chatButton.click();
        return;
      }
    }

    // fallback (force open)
    if (chatEl) {
      chatEl.setAttribute('is-open', 'true');
    }
  }

});



// marquee slider
// new Splide(".marquee-slider", {
//   type: "loop",
//   perPage: 4,
//   arrows:  false,
//   pagination:  false,
//   focus: "center",
//   gap: "1em",

//   breakpoints: {
//     1440: {
//       perPage: 3,
//     },
//     1024: {
//       perPage: 2,
//       gap: "0.8em",
//     },
//     767: {
//       perPage: 1.5,
//       gap: "0.5em",
//     },
//     576: {
//       perPage: 1,
//       gap: "0.5em",
//     }
//   }

// }).mount(window.splide.Extensions);

new Splide(".marquee-slider", {
  type: "loop",
  autoWidth: true,
  arrows: false,
  pagination: false,
  gap: "4rem",
  drag: "free",
  focus: "center",
}).mount(window.splide.Extensions);



const interval = setInterval(() => {
    const parent = document.querySelector('.na-back-in-stock-container');
    
    if (parent) {
        const btn = parent.querySelector('.nm-btn');
        
        if (btn) {
            btn.textContent = 'NOTIFY ME';
            clearInterval(interval);
        }
    }
}, 500);




// end
  });